import { useEffect } from 'react'
import Navbar from '@/components/feature/Navbar'
import Footer from '@/components/feature/Footer'
import ScrollToTop from '@/components/base/ScrollToTop'
import HeroSection from './components/HeroSection'
import CategoryGrid from './components/CategoryGrid'
import FeaturedSection from './components/FeaturedSection'
import HotList from './components/HotList'
import LatestNews from './components/LatestNews'
import NewsletterSection from './components/NewsletterSection'

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '色里番精选推荐 · 完整分类导航',
    description: '探索色里番的完整世界，精选高品质色里番作品分类导航，涵盖热门番剧、新番推荐、经典回顾等内容。',
    url: 'https://tomleeled.cn/',
    inLanguage: 'zh-CN',
    isPartOf: { '@type': 'WebSite', name: '色里番精选推荐', url: 'https://tomleeled.cn/' },
  }

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedSection />
        <HotList />
        <LatestNews />
        <NewsletterSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  )
}